import styled from '@emotion/styled'

export const BillBookkeepingTagWrapper = styled.div`
  display: flex;
  align-items: center;
`
